import { __assign, __rest } from "tslib";
import * as React from 'react';
import { SuggestionList } from '../../components/index.js';
import { useForwardedRef, useSuggestionList } from '../../hooks/index.js';
export var InputField = React.forwardRef(function (_a, ref) {
    var label = _a.label, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.multiline, multiline = _c === void 0 ? false : _c, onChange = _a.onChange, error = _a.error, value = _a.value, children = _a.children, onSuggest = _a.onSuggest, props = __rest(_a, ["label", "type", "multiline", "onChange", "error", "value", "children", "onSuggest"]);
    var cls = "form-control".concat(value ? ' active' : '').concat(error ? ' error' : '');
    var _d = useSuggestionList(), el = _d[0], suggestionsInfos = _d[1], setSuggestionsInfos = _d[2], loadSuggestions = _d[3];
    var input = useForwardedRef(ref);
    var change = React.useCallback(function (e) {
        var value = e.target.value;
        if (typeof onSuggest === 'function') {
            var results = onSuggest === null || onSuggest === void 0 ? void 0 : onSuggest(value);
            loadSuggestions(results);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }, [onChange, onSuggest]);
    var select = React.useCallback(function (value) {
        input.current.value = value;
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { cursor: -1, isVisible: false })); });
    }, [onChange]);
    var keyboardNavigation = function (ev) {
        var key = ev.key;
        if (!suggestionsInfos.isVisible) {
            // nothing to do here
        }
        else if (key === 'Enter') {
            if (suggestionsInfos.cursor !== -1) {
                var suggestion = suggestionsInfos.suggestions[suggestionsInfos.cursor];
                var suggestedValue = typeof suggestion === 'string' ? suggestion : suggestion.value;
                if (typeof value === 'undefined') {
                    input.current.value = suggestedValue;
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(suggestedValue);
                setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { cursor: -1, isVisible: false })); });
                ev.preventDefault();
            }
        }
        else if (key === 'ArrowDown' || key === 'ArrowUp') {
            var len = suggestionsInfos.suggestions.length;
            if (len > 0) {
                var delta = suggestionsInfos.isVisible ? (key === 'ArrowDown' ? +1 : -1) : 0;
                var cursor_1 = (suggestionsInfos.cursor + delta + len) % len;
                setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { cursor: cursor_1, isVisible: true })); });
            }
            ev.preventDefault();
        }
        else if (key === 'Escape') {
            setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { isVisible: false })); });
            ev.preventDefault();
        }
    };
    return (React.createElement("div", { className: "form-group", ref: el },
        multiline ? (React.createElement("textarea", __assign({}, props, { rows: props.rows || 5, className: cls, onKeyDown: keyboardNavigation, value: value, ref: input, onChange: change }))) : (React.createElement("input", __assign({}, props, { type: type, className: cls, onKeyDown: keyboardNavigation, value: value, ref: input, onChange: change }))),
        label && React.createElement("label", { className: "text-floating" }, label),
        children,
        React.createElement(SuggestionList, { onSelect: select, loading: suggestionsInfos.loading, visible: suggestionsInfos.isVisible, suggestions: suggestionsInfos.suggestions, cursor: suggestionsInfos.cursor })));
});
//# sourceMappingURL=index.js.map